"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Assignment = /** @class */ (function () {
    function Assignment() {
    }
    return Assignment;
}());
exports.Assignment = Assignment;
